module.exports = __webpack_public_path__ + "static/media/iconfinder_Vector-icons_39_1041628.2de97486.svg";